export const deleteCourse = (payload?: any) => ({
    type: "@saga/DELETE_COURSE",
    payload
});

